<template>
  <div>
    <InputLabel :labelClass="label_class" :forId="id" :label="label" />
    <div class="col-span-5 md:col-span-7 relative">
      <span class="absolute bottom-0 left-0 py-1 px-3 font-medium"> Rp </span>
      <input
        :id="id"
        :value="formattedValue"
        :class="input_class"
        :disabled="is_disabled"
        :required="is_required"
        v-bind="$attrs"
        @input="handleInput"
        :placeholder="placeholder"
        type="text"
        class="block ps-12 text-lg mt-1 flex-1 rounded-3xl border-none bg-transparent border-white/50 px-3 py-1 text-white placeholder:text-gray-300 placeholder:text-[12px] sm:text-sm sm:leading-6 focus:outline-none focus:ring-0 focus:shadow-lg focus:shadow-white/70 transition-shadow duration-500"
      />
    </div>
  </div>
</template>

<script>
import InputLabel from "./InputLabel.vue";
export default {
  name: "InputRupiah",
  components: {
    InputLabel,
  },
  props: {
    label: String,
    label_class: String,
    id: String,
    name: String,
    placeholder: String,
    input_class: String,
    modelValue: [String, Number],
    is_disabled: Boolean,
    is_required: Boolean,
  },
  emits: ["update:modelValue"],
  inheritAttrs: false,
  computed: {
    formattedValue() {
      return this.formatRupiah(this.modelValue);
    },
  },
  methods: {
    formatRupiah(value) {
      let numericValue =
        typeof value === "string"
          ? parseInt(value.replace(/\D/g, ""), 10)
          : value;
      if (isNaN(numericValue)) return "";
      return new Intl.NumberFormat("id-ID", {
        maximumFractionDigits: 0,
      }).format(numericValue);
    },
    unformatRupiah(value) {
      return value.replace(/\D/g, "");
    },
    handleInput(event) {
      const inputValue = event.target.value;
      const unformattedValue = this.unformatRupiah(inputValue);
      const numericValue = parseInt(unformattedValue, 10);

      this.$emit("update:modelValue", numericValue);
      event.target.value = this.formatRupiah(numericValue);
    },
  },
};
</script>
